<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div v-else>
    <div class="testoblu" style="margin-bottom: 20px; padding-top: 5px;">{{ S0004 }}</div>
    <div class="backgroudlistwhite" style="display: flex; padding-top: 10px;padding-bottom: 10px;padding-left:5px; margin-top: 10px;margin-bottom: 10px; border: 4px solid #49c0de;">
      <div style="width: 24em;min-width: 8em; padding-top: 5px;" class="testoblu">{{ S0005 }}</div>
      <div style="width: 7em; min-width: 3em; padding-top: 5px;" class="testoblu">{{ S0006 }}</div>
      <div v-if="breakpoint.current=='xs'" style="width: 7em; margin-top: 8px; " class="testoblu"><img width="41" height="15" src="../assets//mela-rossa.png" /></div>
      <div v-if="breakpoint.current=='xs'" style="width: 7em; margin-top: 8px " class="testoblu"><img width="41" height="15" src="../assets//mela-verde.png" /></div>
      <div v-if="breakpoint.current=='xs'" style="width: 7em; margin-top: 8px " class="testoblu"><img width="41" height="15" src="../assets//mela-blu.png" /></div>
      <div v-if="breakpoint.current=='xs'" style="width: 7em; margin-top: 8px " class="testoblu"><img width="41" height="15" src="../assets//mela-viola.png" /></div>
      <div v-if="breakpoint.current!='xs'" style="width: 7em; " class="testoblu"><img width="82" height="30" src="../assets//mela-rossa.png" /></div>
      <div v-if="breakpoint.current!='xs'" style="width: 7em; " class="testoblu"><img width="82" height="30" src="../assets//mela-verde.png" /></div>
      <div v-if="breakpoint.current!='xs'" style="width: 7em; " class="testoblu"><img width="82" height="30" src="../assets//mela-blu.png" /></div>
      <div v-if="breakpoint.current!='xs'" style="width: 7em; " class="testoblu"><img width="82" height="30" src="../assets//mela-viola.png" /></div>
    </div>
    <div style="display: flex;" v-for="(component, idx) in components" :class="!iseven(idx) ? 'even' : ''"
      :key="component.id">
      
      <div style="width: 20em; padding-top: 5px;">{{ component.description }}</div>
      <div style="width: 7em; padding-top: 5px; text-align: center;">{{ component.unitM }}</div>
      <div style="width: 7em; text-align: center;">
        <img src="../assets/check.png" v-if="component.bda1998 == 1" />
      </div>
      <div style="width: 7em; text-align: center;">
        <img src="../assets/check.png" v-if="component.bda2008 == 1" />
      </div>
      <div style="width: 7em; text-align: center;">
        <img src="../assets/check.png" v-if="component.bda2015 == 1" />
      </div>
      <div style="width: 7em; text-align: center;">
        <img src="../assets/check.png" v-if="component.bda2022 == 1" />
      </div>
    </div>
  </div>
  <MessageComponent v-if="message != ''" :message="message" :messageType="messagetype"></MessageComponent>
</template>

<script>
import { useBreakpoint } from "vuestic-ui";
import { app } from "../main.js";
import api from "../js/apiConsts.js";
import apiConsts from "../js/apiConsts.js";
import { getSTRING } from "@/js/utils";
import { axiosPost } from "../js/apiService.js";
import LoaderComponent from "../components/LoaderComponent.vue";
import MessageComponent from "@/components/MessageComponent.vue";
export default {
  name: "PageComponents",
  components: {
    LoaderComponent,
    MessageComponent
  },
  data() {
    return {
      currentLang: this.$route.params.lang,
      loadingData: false,
      components: null,
      TITOLO: '',
      S0004: '',
      S0005: '',
      S0006: '',
      message: '',
      messagetype: 1,
      breakpoint : useBreakpoint()
    };
  },
  async mounted() {
    this.TITOLO = getSTRING(this.currentLang, "TITOLO", apiConsts.TITOLOAPP)
    this.S0004 = getSTRING(this.currentLang, "S0004", "Componenti")
    this.S0005 = getSTRING(this.currentLang, "S0005", "Componente")
    this.S0006 = getSTRING(this.currentLang, "S0006", "Unità")
    await this.loadFoodDetail();
  },
  unmounted() {
    app.config.globalProperties.$GenericError = false;
  },
  methods: {
    iseven(num) {
      return num % 2 == 0;
    },
    async loadFoodDetail() {
      this.message = '';
      this.loadingData = true;
      await axiosPost(api.APISummaryComponents, {
        language: this.currentLang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
      })
        .then((response) => {
          this.loadingData = false;
          let res = response.data;
          this.components = null;
          if (res.success) {
            this.components = res.components;
          } else {
            this.message = res.message;
          }
        })
        .catch((err) => {
          this.loadingData = false;
          this.message = err.message;
        });
    },
  },
};
</script>

<style scoped>
.even {
  background-color: azure;
}
</style>